import angular from 'angular';

angular.module('cloudX').directive('ngModel', [
  function() {
    return {
      restrict: 'A',
      require: ['ngModel', '^?bindErrors'],
      link: function(scope, element, attributes, ctrls) {
        var ngModel = ctrls[0];
        var bindErrors = ctrls[1];
        if (!ngModel) return;
        if (!bindErrors) return;
        ngModel.$viewChangeListeners.push(function() {
          bindErrors.refreshErrors(ngModel.$error);
        });
        scope.$on('$destroy', function() {
          bindErrors.refreshErrors();
        });
      },
    };
  },
]);
